<!-- static content data from lang: past_script_details -->
<template>
    <div class="container h-100">
        <div class="py-3 h-100" v-loading="loading">
            <template v-if="errored">
                <NotFound/>
            </template>
            <template v-else-if="data">
                <b-card class="script-details">
                    <template slot="header">
                        <div class="text-center">
                            <h5 class="id">{{lang.label.scriptId}}: {{(data.scriptNo!=''? data.scriptNo
                                :lang.label.nodata)}}</h5>
                            <p class="date">{{lang.label.date}}: <span
                                    v-html="(data.createdAt!='' ?formatScriptDate(data.createdAt) :lang.label.nodata)">  </span>
                            </p>
                        </div>
                    </template>
                    <div class="full-detail">
                        <div class="row">
                            <div class="col-md-4">
                                <b-card class="card-box" body-class="p-0">
                                    <div class="row">
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.patientName}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.name!=''? data.name :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.gender}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.gender!=''? data.gender :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.idNumber}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.idNumber!=''? data.idNumber :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.icdCode}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.icdCode? data.icdCode :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.patientMinor}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.isMinor!= ""? (data.isMinor==1? 'Yes':'No') :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.parentName}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.parentName!=''? data.parentName :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.parentIDNumber}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.idNumberParent!=''? data.idNumberParent :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.medicineRequired}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.medicine!=''? data.medicine :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.specialInstructions}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.specialInstructions!=''? data.specialInstructions :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.dob}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.dob!=''? formatDob(data.dob) :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.bloodGroup}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{ (data.bloodGroup!=''? data.bloodGroup :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.phoneNumber}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.mobile!=''? data.mobile :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.address}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block"
                                                  v-html="(data.address!=''? formatAddress(data.address) :lang.label.nodata)"></span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.patientNotes}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{ (data.nurseNote!=''? data.nurseNote :lang.label.nodata)}}</span>
                                        </div>
                                    </div>
                                </b-card>
                            </div>
                            <div class="col-md-4">
                                <b-card class="card-box" body-class="p-0 border-left">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <span class="my-2 d-block">{{lang.label.namePharmacist}}:</span>
                                        </div>
                                        <div class="col-md-6">
                                            <span class="my-2 d-block">{{(data.pharmacistName!=''? data.pharmacistName :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-md-6">
                                            <span class="my-2 d-block">{{lang.label.phoneNumber}}:</span>
                                        </div>
                                        <div class="col-md-6">
                                            <span class="my-2 d-block">{{(data.pharmacistMobile!=''? data.pharmacistMobile :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-md-6">
                                            <span class="my-2 d-block">{{lang.label.email}}:</span>
                                        </div>
                                        <div class="col-md-6">
                                            <span class="my-2 d-block">{{(data.pharmacistEmail!=''? data.pharmacistEmail :lang.label.nodata)}}</span>
                                        </div>
                                    </div>
                                    <template slot="footer">
                                        <div class="b-footer">
                                            <b-btn type="button" variant="primary" class="w-100"
                                                   v-clipboard:copy=data.shared_url
                                                   v-clipboard:success="onCopy"
                                                   v-clipboard:error="onError"> {{data.prescription ?
                                                lang.label.buttons.copyEScript: lang.label.buttons.copyScript}}
                                            </b-btn>
                                        </div>
                                    </template>
                                </b-card>
                            </div>
                            <div class="col-md-4">
                                <b-card class="card-box" body-class="p-0 border-left">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <span class="my-2 d-block">{{lang.label.status}}: {{(data.status!=''? data.status :lang.label.nodata)}}</span>
                                        </div>

                                        <div class="col-md-12">
                                            <span class="my-2 d-block">{{lang.label.totalPrice}}: {{(data.scriptPrice!=''? 'R '+data.scriptPrice :lang.label.nodata)}}</span>

                                        </div>
                                        <div class="col-md-12">
                                            <span class="my-2 d-block">{{lang.label.adminCommissionPercentage}}: {{(data.adminCommissionPercentage!=''? data.adminCommissionPercentage+'%' :lang.label.nodata)}}</span>

                                        </div>
                                        <div class="col-md-12">
                                            <span class="my-2 d-block">{{lang.label.adminCommissionAmount}}: {{(data.adminCommissionAmount!=''? 'R '+data.adminCommissionAmount :lang.label.nodata)}}</span>

                                        </div>
                                        <div class="col-md-12">
                                            <span class="my-2 d-block">{{lang.label.myAmount}}: {{(data.doctorAmount!='' ? 'R '+data.doctorAmount : lang.label.nodata)}}</span>

                                        </div>
                                        <!--<div class="col-md-12" v-if="data.prescription">-->
                                        <div class="col-6 col-sm-4" v-if="data.prescription">
                                            <span class="my-2 d-block">{{lang.label.prescription}}:</span>
                                        </div>
                                        <div class="col-6 col-lg-5" v-if="data.prescription">
                                            <span class="my-2 d-block"
                                                  v-html="(data.prescription!=''? formatPrescription(data.prescription) :lang.label.nodata)"></span>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="demo-image__preview mt-3">
                                            <template v-for="(data, index) in pdf">
                                                <div class="silentbox-item pdf-file">
                                                    <img src="../assets/styles/img/pdf.png" alt=""/>
                                                    <div class="item-btn">
                                                        <a :href="data" class=" btn btn-sm btn-secondary" :key="index"
                                                           :download="data">
                                                            <!--<iframe id="my_iframe" style="display:none;"></iframe>-->
                                                            <i class="fas fa-download"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </template>
                                            <template v-if="images.length > 0">
                                                <silent-box :gallery="images"></silent-box>
                                            </template>
                                        </div>
                                    </div>
                                    <template slot="footer">
                                        <div class="b-footer">
                                            <b-btn variant="primary" class="w-100">
                                                <a style="color:#FFF" :href="mailDetails" target="_blank">{{data.prescription?
                                                    lang.label.buttons.shareEScript:
                                                    lang.label.buttons.shareScript}}
                                                </a>
                                            </b-btn>
                                        </div>
                                    </template>
                                </b-card>
                            </div>
                        </div>
                    </div>
                </b-card>
            </template>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import jsondata from "../assets/json/data.json";
    import VueSilentbox from "vue-silentbox";

    Vue.use(VueSilentbox);
    import VueClipboard from 'vue-clipboard2';
    import {mapGetters} from "vuex";

    Vue.use(VueClipboard);
    var moment = require('moment'); // require
    import NotFound from "../components/NotFound.vue";

    export default {

        components: {
            NotFound
        },
        data() {
            return {
                data: {},
                mailDetails: '',
                shareUrl: '',
                id: this.$route.params.id,
                lang: this.$lang.past_script_details,
                images: [],
                pdf: [],
                loading: true,
                errored: false,
                models: {
                    idNumber: "",
                    patientMinor: [],
                    parentName: "",
                    parentIDNumber: "",
                    medicineRequired: "",
                    specialInstructions: "",
                }
            }
        },
        computed: {
            ...mapGetters({
                login: "login",
            })
        },
        mounted() {
            let data = {
                "id": this.id
            };
            let self = this;
            this.$store.dispatch('getPastScriptDetails', data)
                .then(response => {
                    let flag = false;
                    if (response.data.prescription) {
                        flag = true;
                    }
                    self.$store.commit('setEScript', flag);
                    self.data = response.data;
                    self.shareUrl = self.scriptDetail();
                    this.loading = false;
                    self.mailDetails = self.scriptDetails();
                    response.data.scriptImages.forEach(function (item) {

                        let type = item.split('.').pop();
                        if (type === "PDF" || type === "pdf") {
                            self.pdf.push(item);
                        } else {
                            self.images.push({src: item});
                        }
                    });
                })
                .catch(error => {
                    this.errored = true;
                })
                .finally(() => this.loading = false)

        },
        methods: {
            formatAddress(address) {
                return address.replace(/\n/g, '<br/>');
            },
            scriptDetail() {
//                return 'Dear '+this.data.patientsName+', you submitted a request for a script / form to '+this.login.name+'. If you requested the document, please click this link '+'"' +this.data.shared_url +'"'+' to make payment and download the document. Thank you, '+this.login.name;
            },
            scriptDetails() {
                let subject = 'mailto:' + this.data.pEmail + '?subject=Payscript – Script / Form from ' + this.login.practiceName + ' &body=';
                let body = 'Dear ' + this.data.patientsName + ',' + '%0D%0A%0D%0A' + 'You submitted a request for a script / form to ' + this.login.practiceName + '. If you requested the document, please ' + 'OPEN ' + this.data.shared_url + ' to pay and access the document.' + '%0D%0A%0D%0A' + 'Thank you, %0D%0A' + this.login.practiceName;
                return subject + body;
            },
            formatDob(date) {
                return moment(date).format('DD/MM/YYYY');
            },
            formatScriptDate(date) {
                let format = moment(date).format('Do MMM YYYY');
                moment.locale('en', {
                    ordinal: num => {
                        const b = num % 10;
                        const output = (~~(num % 100 / 10) === 1) ? 'th' :
                            (b === 1) ? 'st' :
                                (b === 2) ? 'nd' :
                                    (b === 3) ? 'rd' : 'th';
                        return num + '<sup>' + output + '</sup>';
                    },
                });

                return moment(date).format('Do MMM YYYY');
            },
            onCopy: function (e) {

                if (this.data.shared_url != "") {
                    return this.notifyVue('success');
                } else {
                    return this.notifyVueError('error');
                }
            },
            onError: function (e) {
                this.notifyVueError('error');
            },
            notifyVue(type = 'success') {

                this.$notify({

                    message: this.lang.label.copiedlink,
                    timeout: 5000,
                    type
                });
            },
            notifyVueError(type = 'error') {

                this.$notify({

                    message: this.lang.label.errorIncopyLink,
                    timeout: 5000,

                    type
                });
            },
            formatAddress(address) {
                if (address) {
                    return address.replace(/\n/g, '<br/>');
                }
            },
            formatPrescription(prescription) {
                if (prescription) {
                    return prescription.replace(/\n/g, '<br/>');
                }

            },
            Download(url) {
                url = this.pdf;
                document.getElementById('my_iframe').src = url;
            }

        }
    };
</script>
